import * as React from 'react';
import { User } from '../../../models';
import { PVASelect, PVASelectOption } from './PVASelect';
import { FilterStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVAUserSelectProps {
    options: User[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    defaultOptions?: Array<{ id: number; value: string }>;
    typeaheadTimerInSeconds?: number;
    disabled?: boolean;
}

@inject('FilterStore') @observer
export class PVAUserSelect extends React.Component<PVAUserSelectProps> {
    private mapUsersToOptions(users: User[]): PVASelectOption[] {
        return (users || []).map((user: User) => ({
            id: user.id,
            label: `${user.lastName}, ${user.firstName}${user.resultsArePrivate ? ' (Private)' : ''}`
        }));
    }

    private sortOptions = (a: PVASelectOption, b: PVASelectOption) => {
        // Sorting by label is equivalent to sorting by last name then first name due to the label format
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        return 0;
    }

    render() {
        const { options, selected, onChange, defaultOptions, typeaheadTimerInSeconds, disabled } = this.props;
        const mapped = this.mapUsersToOptions(options);
        const mappedDefaults = defaultOptions ? defaultOptions.map((o) => ({ id: o.id, label: o.value })) : undefined;

        return (
            <PVASelect
                options={mapped}
                selected={selected}
                onChange={onChange}
                defaultOptions={mappedDefaults}
                noSelectTitle={'- Select User -'}
                sortOptions={this.sortOptions}
                typeaheadTimerInSeconds={typeaheadTimerInSeconds}
                disabled={disabled}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAUserSelect.tsx